/* eslint no-unused-vars: "off" */
import Swiper from 'swiper/dist/js/swiper.min';
import searchForm from '../components/search-form';

export default {
  init() {
    // JavaScript to be fired on the home page
    // let featuredProducts = $('.c-featured-products .c-featured-product__single')
    // featuredProducts.on('hover', function() {
    //   $(this).toggleClass('active');
    // })

    searchForm.attachListeners();

    if (document.querySelector('.intro-slider')) {
      let introSlider = new Swiper('.intro-slider', {
        init: false,
        // Optional parameters
        loop: true,

        autoplay: {
          delay: 5000,
        },

        // If we need pagination
        pagination: {
          el: '.swiper-pagination',
          dynamicBullets: true,
        },

        // Navigation arrows
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },

        // And if we need scrollbar
        scrollbar: {
          el: '.swiper-scrollbar',
          hide: true,
          snapOnRelease: true,
        },
        on: {
          init: function() {
            // let bodyWidth   = $('body').width()
            // let slideWidth = Math.round( bodyWidth * 0.8 )
            // let slideTitle  = $('.intro-slider .swiper-slide__title')
            //     slideTitle.css({
            //       right: bodyWidth - slideWidth,
            //       left: 'unset',
            //     })
          },
        },
      });

      introSlider.init();
    }

    // Home Page Swiper
    let bridalSlider = new Swiper('#bridal-slider', {
      init: false,
      // Optional parameters
      loop: true,

      // If we need pagination
      pagination: {
        el: '.swiper-pagination',
        dynamicBullets: true,
      },
      autoplay: {
        delay: 4000,
      },
      // Navigation arrows
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },

      // And if we need scrollbar
      scrollbar: {
        el: '.swiper-scrollbar',
        hide: true,
        snapOnRelease: true,
      },
      on: {
        init: function() {
          // let bodyWidth   = $('body').width()
          // let slideWidth = Math.round( bodyWidth * 0.8 )
          // let slideTitle  = $('.section-slider .swiper-slide__title')
          //     slideTitle.css({
          //       right: bodyWidth - slideWidth,
          //       left: 'unset',
          //     })
        },
      },
    });

    bridalSlider.init();
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js